import {
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import axios from "axios";
import BASEUtils from "../../../../@BASE/utils";
import { addPage, removePage, updatePage } from "./pageSlice";

export const getPages = createAsyncThunk(
  "pages/getPages",
  async (params, { getState }) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_SERVICE_URL}/api/pages`
    );

    const data = await response.data;

    return { data };
  }
);

const pagesAdapter = createEntityAdapter({});

export const selectSearchText = ({ pages }) => pages.list.searchText;

export const { selectAll: selectPages, selectById: selectPagesById } =
  pagesAdapter.getSelectors((state) => state.pages.list);

export const selectFilteredPages = createSelector(
  [selectPages, selectSearchText],
  (pages, searchText) => {
    if (searchText.length === 0) {
      return pages;
    }
    return BASEUtils.filterArrayByString(pages, searchText);
  }
);

export const selectGroupedFilteredPages = createSelector(
  [selectFilteredPages],
  (pages) => {
    return pages
      .sort((a, b) =>
        a.title.localeCompare(b.title, "es", {
          sensitivity: "base",
        })
      )
      .reduce((r, e) => {
        // get first letter of title of current element
        const group = e.title[0];
        // if there is no property in accumulator with this letter create it
        if (!r[group]) r[group] = { group, children: [e] };
        // if there is push current element to children array for that letter
        else r[group].children.push(e);
        // return accumulator
        return r;
      }, {});
  }
);

const pagesSlice = createSlice({
  name: "pages",
  initialState: pagesAdapter.getInitialState({
    searchText: "",
  }),
  reducers: {
    setPagesSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
  },
  extraReducers: {
    [updatePage.fulfilled]: pagesAdapter.upsertOne,
    [addPage.fulfilled]: pagesAdapter.addOne,
    [removePage.fulfilled]: (state, action) =>
      pagesAdapter.removeOne(state, action.payload),
    [getPages.fulfilled]: (state, action) => {
      const { data, routeParams } = action.payload;
      pagesAdapter.setAll(state, data);
      state.searchText = "";
    },
  },
});

export const { setPagesSearchText } = pagesSlice.actions;

export const selectPagesSearchText = ({ pages }) => pages.list.searchText;

export const selectPageEntities = ({ pages }) => pages.list.entities;

export default pagesSlice.reducer;
